import Immutable from 'immutable'
import PROTOCOL_API_LEVEL from '../protocolApiLevel'

const LUNAR = {
  name: 'lunar',
  key: 'lunar',
  icon: 'icon-tuceng-riqi',
  expand: false,
  hide: false,
  canClick: true,
  order: ''
}

const BASIC_IMAGE = {
  name: 'basic_image',
  key: 'image',
  icon: 'icon-tuceng-tupian',
  expand: false,
  hide: false,
  canClick: true,
  order: ''
}

const BASIC_TEXT = {
  name: 'basic_text',
  key: 'text',
  icon: 'icon-tuceng-wenzi',
  expand: false,
  hide: false,
  canClick: true,
  order: ''
}


const HRV = {
  name: 'hrv',
  key: 'hrv',
  // icon: 'icon-tuceng-bushu',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.hrv,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    }
  ]
}

const BIO_CHARGE = {
  name: 'bio_charge',
  key: 'bio_charge',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.bio_charge,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'pointer_progress',
      key: 'pointer_progress',
      icon: 'icon-tuceng-zhizhen',
      checked: false
    },
    {
      name: 'normal_progress',
      key: 'progress',
      icon: 'icon-tuceng-shiliangjindu',
      checked: false
    },
    {
      name: 'image_progress',
      key: 'image_progress',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'jump_area',
      key: 'jumpable',
      icon: 'icon-tuceng-requ',
      checked: false
    }
  ]
}

const LTHR = {
  name: 'lthr',
  key: 'lthr',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.lthr,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'jump_area',
      key: 'jumpable',
      icon: 'icon-tuceng-requ',
      checked: false
    }
  ]
}

const LTPACE = {
  name: 'ltpace',
  key: 'ltpace',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.ltpace,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'jump_area',
      key: 'jumpable',
      icon: 'icon-tuceng-requ',
      checked: false
    }
  ]
}

const RECOVERY_TIME = {
  name: 'recovery_time',
  key: 'recovery_time',
  // icon: 'icon-tuceng-bushu',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.recovery_time,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'pointer_progress',
      key: 'pointer_progress',
      icon: 'icon-tuceng-zhizhen',
      checked: false
    },
    {
      name: 'normal_progress',
      key: 'progress',
      icon: 'icon-tuceng-shiliangjindu',
      checked: false
    },
    {
      name: 'jump_area',
      key: 'jumpable',
      icon: 'icon-tuceng-requ',
      checked: false
    }
  ]
}

const ALTITUDE = {
  name: 'altitude',
  key: 'altitude',
  // icon: 'icon-tuceng-bushu',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.altitude,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'jump_area',
      key: 'jumpable',
      icon: 'icon-tuceng-requ',
      checked: false
    }
  ]
}

const SLEEP = {
  name: 'sleep',
  key: 'sleep',
  // icon: 'icon-tuceng-bushu',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.sleep,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'pointer_progress',
      key: 'pointer_progress',
      icon: 'icon-tuceng-zhizhen',
      checked: false
    },
    {
      name: 'normal_progress',
      key: 'progress',
      icon: 'icon-tuceng-shiliangjindu',
      checked: false
    },
    {
      name: 'image_progress',
      key: 'image_progress',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'jump_area',
      key: 'jumpable',
      icon: 'icon-tuceng-requ',
      checked: false
    }
  ]
}

const MONTH_RUN_TIMES = {
  name: 'month_run_times',
  key: 'month_run_times',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.month_run_times,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    }
  ]
}

const MONTH_RUN_DISTANCE = {
  name: 'month_run_distance',
  key: 'month_run_distance',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.month_run_distance,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    }
  ]
}

const FLOOR = {
  name: 'floor',
  key: 'floor',
  expand: false,
  hide: false,
  order: '',
  apiLevel: PROTOCOL_API_LEVEL.floor,
  children: [
    {
      name: 'data',
      key: 'text',
      icon: 'icon-tuceng-shuzi',
      checked: false
    },
    {
      name: 'icon',
      key: 'icon',
      icon: 'icon-tuceng-tupian',
      checked: false
    },
    {
      name: 'jump_area',
      key: 'jumpable',
      icon: 'icon-tuceng-requ',
      checked: false
    }
  ]
}

const MENU = Immutable.fromJS({
  image: BASIC_IMAGE,
  text: BASIC_TEXT,
  idle_background: {
    name: 'background',
    key: 'idle_background',
    icon: 'icon-tuceng-beijing',
    expand: false,
    hide: false,
    order: '',
    canClick: true
  },
  analog_clock: {
    name: 'pointer_time',
    key: 'analog_clock',
    icon: 'icon-tuceng-zhizhenshijian',
    expand: false,
    hide: false,
    order: '',
    children: [
      {
        name: 'hour_pointer',
        key: 'hour',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'min_pointer',
        key: 'minute',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      }
    ]
  },
  digital_clock: {
    name: 'digital_time',
    key: 'digital_clock',
    icon: 'icon-tuceng-shuzishijian',
    expand: false,
    hide: false,
    order: '',
    children: [
      {
        name: 'hr',
        key: 'hour',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'min',
        key: 'minute',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'ampm',
        key: 'ampm',
        icon: 'icon-tuceng-wenzi',
        checked: false
      }
    ]
  },
  // progress_clock: {
  //     name: 'progress_time',
  //     key: 'progress_clock',
  //     icon: 'icon-tuceng-jindushijian',
  //     expand: false,
  //     hide: false,
  //     order: '',
  //     children: [
  //         {
  //             name: 'hr',
  //             key: 'hour',
  //             icon: 'icon-tuceng-jindushijian',
  //             checked: false,
  //         },
  //         {
  //             name: 'min',
  //             key: 'minute',
  //             icon: 'icon-tuceng-jindushijian',
  //             checked: false,
  //         },
  //     ],
  // },
  pai: {
    name: 'week_pai',
    key: 'pai',
    icon: 'icon-tuceng-pai',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.pai,
    children: [
      {
        name: 'data',
        key: 'weekly',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  pai_daily: {
    name: 'day_pai',
    key: 'pai_daily',
    icon: 'icon-tuceng-pai',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.pai_daily,
    children: [
      {
        name: 'data',
        key: 'daily',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  stand: {
    name: 'standing_goal',
    key: 'stand',
    icon: 'icon-tuceng-zhanli',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.stand,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'jump_area',
        key: 'jumpable',
        icon: 'icon-tuceng-requ',
        checked: false
      }
    ]
  },
  // aqi: {
  //   name: 'air_quality',
  //   key: 'aqi',
  //   icon: 'icon-tuceng-kongqizhiliang',
  //   expand: false,
  //   hide: false,
  //   order: '',
  //   children: [
  //     {
  //       name: 'data',
  //       key: 'text',
  //       icon: 'icon-tuceng-shuzi',
  //       checked: false
  //     },
  //     {
  //       name: 'icon',
  //       key: 'icon',
  //       icon: 'icon-tuceng-tupian',
  //       checked: false
  //     },
  //     {
  //       name: 'pointer_progress',
  //       key: 'pointer_progress',
  //       icon: 'icon-tuceng-zhizhen',
  //       checked: false
  //     },
  //     {
  //       name: 'normal_progress',
  //       key: 'progress',
  //       icon: 'icon-tuceng-shiliangjindu',
  //       checked: false
  //     },
  //     {
  //       name: 'image_progress',
  //       key: 'image_progress',
  //       icon: 'icon-tuceng-tupian',
  //       checked: false
  //     }
  //   ]
  // },
  humidity: {
    name: 'humidity',
    key: 'humidity',
    icon: 'icon-tuceng-wenjianjiakai',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.humidity,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  uvi: {
    name: 'uv_degree',
    key: 'uvi',
    icon: 'icon-tuceng-ziwaixian',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.uvi,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  altimeter: {
    name: 'altimeter',
    key: 'altimeter',
    icon: 'icon-tuceng-wenjianjiakai',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.altimeter,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  battery: {
    name: 'battery',
    key: 'battery',
    icon: 'icon-tuceng-dianliang',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.battery,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  heart_rate: {
    name: 'heart_rate',
    key: 'heart_rate',
    icon: 'icon-tuceng-xinshuai',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.heart_rate,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  calorie: {
    name: 'calorie',
    key: 'calorie',
    icon: 'icon-tuceng-xiaohao',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.calorie,
    children: [
      {
        name: 'data',
        key: 'current',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  step: {
    name: 'steps',
    key: 'step',
    icon: 'icon-tuceng-bushu',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.step,
    children: [
      {
        name: 'real_time_steps',
        key: 'current',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'target_steps',
        key: 'target',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  distance: {
    name: 'distance',
    key: 'distance',
    icon: 'icon-tuceng-juli',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.distance,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  weather: {
    name: 'weather',
    key: 'weather',
    icon: 'icon-tuceng-tianqi',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.weather,
    children: [
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  moon: {
    name: 'moon',
    key: 'moon',
    icon: 'icon-tuceng-tianqi',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.moon,
    children: [
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  moon_rise: {
    name: 'moon_rise',
    key: 'moon_rise',
    icon: 'icon-tuceng-tianqi',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.moon_rise,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'jump_area',
        key: 'jumpable',
        icon: 'icon-tuceng-requ',
        checked: false
      }
    ]
  },
  moon_set: {
    name: 'moon_set',
    key: 'moon_set',
    icon: 'icon-tuceng-tianqi',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.moon_set,
    children: [
      {
        name: 'data',
        key: 'text',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'jump_area',
        key: 'jumpable',
        icon: 'icon-tuceng-requ',
        checked: false
      }
    ]
  },
  temperature: {
    name: 'temperature',
    key: 'temperature',
    icon: 'icon-tuceng-wendu',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.temperature,
    children: [
      {
        name: 'real_time_temp',
        key: 'current',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'lowest_temp',
        key: 'low',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'highest_temp',
        key: 'high',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      }
    ]
  },
  sun: {
    name: 'sunrise_sunset',
    key: 'sun',
    icon: 'icon-tuceng-wenjian',
    expand: false,
    hide: false,
    order: '',
    apiLevel: PROTOCOL_API_LEVEL.sun,
    children: [
      {
        name: 'current_time',
        key: 'current',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'sunrise',
        key: 'high',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'sunset',
        key: 'low',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'icon',
        key: 'icon',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      },
      {
        name: 'normal_progress',
        key: 'progress',
        icon: 'icon-tuceng-shiliangjindu',
        checked: false
      },
      {
        name: 'image_progress',
        key: 'image_progress',
        icon: 'icon-tuceng-tupian',
        checked: false
      }
    ]
  },
  date: {
    name: 'date',
    key: 'date',
    icon: 'icon-tuceng-riqi',
    expand: false,
    hide: false,
    order: '',
    children: [
      {
        name: 'year',
        key: 'year',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'month',
        key: 'month',
        icon: 'icon-tuceng-shuzi',
        checked: false
      },
      {
        name: 'day',
        key: 'day',
        icon: 'icon-tuceng-shuzi',
        checked: false
      }
    ]
  },
  lunar: LUNAR,
  week: {
    name: 'week',
    key: 'week',
    icon: 'icon-tuceng-xingqi',
    expand: false,
    hide: false,
    order: '',
    children: [
      {
        name: 'image',
        key: 'text',
        icon: 'icon-tuceng-tupian',
        checked: false
      },
      {
        name: 'pointer_progress',
        key: 'pointer_progress',
        icon: 'icon-tuceng-zhizhen',
        checked: false
      }
      // 星期不支持弧形进度
      // {
      //     name: 'normal_progress',
      //     key: 'progress',
      //     icon: 'icon-tuceng-shiliangjindu',
      //     checked: false,
      // },
    ]
  },

  // message: {
  //     name: 'SMS',
  //     key: 'message',
  //     icon: 'icon-tuceng-duanxin',
  //     expand: false,
  //     hide: false,
  //     order: '',
  //     children: [
  //         {
  //             name: 'image',
  //             key: 'icon',
  //             icon: 'icon-tuceng-tupian',
  //             checked: false,
  //         },
  //         {
  //             name: 'image_progress',
  //             key: 'image_progress',
  //             icon: 'icon-tuceng-tupian',
  //             checked: false,
  //         },
  //         {
  //             name: 'jump_area',
  //             key: 'jumpable',
  //             icon: 'icon-tuceng-requ',
  //             checked: false,
  //         },
  //     ],
  // },
  // phone: {
  //     name: 'phone',
  //     key: 'phone',
  //     icon: 'icon-tuceng-dianhua',
  //     expand: false,
  //     hide: false,
  //     order: '',
  //     children: [
  //         {
  //             name: 'image',
  //             key: 'icon',
  //             icon: 'icon-tuceng-tupian',
  //             checked: false,
  //         },
  //         {
  //             name: 'jump_area',
  //             key: 'jumpable',
  //             icon: 'icon-tuceng-requ',
  //             checked: false,
  //         },
  //     ],
  // },
  hrv: HRV,
  bio_charge: BIO_CHARGE,
  lthr: LTHR,
  ltpace: LTPACE,
  recovery_time: RECOVERY_TIME,
  sleep: SLEEP,
  altitude: ALTITUDE,
  month_run_times: MONTH_RUN_TIMES,
  month_run_distance: MONTH_RUN_DISTANCE,
  floor: FLOOR,
})

export default MENU
